import { render, staticRenderFns } from "./BlockPageSwitcher.vue?vue&type=template&id=4f77dfda&scoped=true&"
import script from "./BlockPageSwitcher.vue?vue&type=script&lang=js&"
export * from "./BlockPageSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./BlockPageSwitcher.vue?vue&type=style&index=0&id=4f77dfda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f77dfda",
  null
  
)

export default component.exports